<template>
  <a-form
    id="formPassword"
    ref="formPassword"
    :form="form"
  >
    <a-form-item label="用户名" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
      <a-input
        size="large"
        type="text"
        disabled
        v-model="operator.no"
      >
        <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }"/>
      </a-input>
    </a-form-item>
    <a-form-item label="姓名" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
      <a-input
        size="large"
        type="text"
        disabled
        v-model="operator.name"
      >
        <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }"/>
      </a-input>
    </a-form-item>
    <footer-tool-bar :style="{ width: isSideMenu() && isDesktop() ? `calc(100% - ${sidebarOpened ? 256 : 80}px)` : '100%' }">
<!--      <a-button type="primary" v-action:save @click="validate">{{ $t('button.save') }}</a-button>-->
<!--      <a-divider type="vertical"/>-->
      <a-button type="primary" @click="handleModify">修改密码</a-button>
    </footer-tool-bar>
    <PasswordModify ref="passwordModify" :operator="operator"/>
  </a-form>
</template>

<script>
  import FooterToolBar from '@/components/FooterToolbar'
  import { mixin, mixinDevice } from '@/utils/mixin'
  import Vue from 'vue'
  import { OPERATOR } from '@/store/mutation-types'
  import PasswordModify from '@/views/user/PasswordModify'
  export default {
    mixins: [mixin, mixinDevice],
    name: 'PersonalSetting',
    components: {
      PasswordModify,
      FooterToolBar,
    },
    data(){
      return{
        form: this.$form.createForm(this),
        operator:Vue.ls.get(OPERATOR)
      }
    },
    methods:{
      handleModify(){
        this.$refs.passwordModify.visible=true
      }
    }
  }
</script>

<style scoped>

</style>